import { formatDateAndTime } from "../utils/format-utils";

export default class Message {
  smsMessageId?: number | null;
  sentAt?: Date | null;
  receivedAt?: Date | null;
  content?: string | null;

  public constructor(params: Message = {} as Message) {
    let {
      smsMessageId = 0,
      sentAt = null,
      receivedAt = null,
      content = "",
    } = params;
    this.smsMessageId = smsMessageId;
    this.sentAt = sentAt;
    this.receivedAt = receivedAt;
    this.content = content;
  }

  get formattedSentAt() {
    return formatDateAndTime(this.sentAt);
  }

  get formattedReceivedAt() {
    return formatDateAndTime(this.receivedAt);
  }
}
